/**
 * This isn't used anywhere
 * @deprecated
 */
import { Inject, OnInit, Directive } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TradeDurations } from 'src/components/trade/tradeBar/constants/tradeDurations';
import { OperationType } from 'src/components/trade/tradeBar/enums/operationType.enum';

// Commenting decorator to prevent angular AOT Compiler to catch it and complain
// @Component({
//   selector: 'hb-trade-capitals-confirmation',
//   templateUrl: 'tradeCapitalsConfirmation.component.html',
// })
@Directive()
export class TradeCapitalsConfirmationComponent implements OnInit {
  operationType = '';
  duration = '';
  orderType = 0;
  tradingAmounts: any = {};
  total = 0;

  constructor(
    private dialogRef: MatDialogRef<TradeCapitalsConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public tradeData: any,
  ) {}

  ngOnInit() {
    this.operationType =
      this.tradeData.operationType === OperationType.BUY ? 'Compra' : 'Venta';

    const durations: any[] = TradeDurations.filter((item: any) => {
      return item.id === this.tradeData.currentTrade.duration;
    });

    this.duration = durations[0].name;

    this.orderType = this.tradeData.currentTrade.selectedOrderType;

    this.tradingAmounts = this.tradeData.currentTrade.tradingAmounts;

    this.total =
      this.tradingAmounts.amount +
      this.tradingAmounts.commission +
      this.tradingAmounts.tax;
  }

  close(value: any): void {
    this.dialogRef.close(value);
  }
}
